export default __webpack_public_path__ + "static/pairing-do-05764590fed3acab513f43fbbece9cc23c902adce5c5952a2a0a666dbee50f5c.png";